import { normalizeDateOnly } from '../../../utils/dateUtils';
import { toDerasarPersonOptions } from '../../../utils/derasarPersonOptions';

export const formatMoney = (value) => Number(value || 0).toLocaleString('en-IN', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const toPreviousDate = (dateStr) => {
  const raw = normalizeDateOnly(dateStr);
  if (!raw) return '';

  const [year, month, day] = raw.split('-').map(Number);
  if (!year || !month || !day) return '';

  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() - 1);

  const prevYear = date.getFullYear();
  const prevMonth = String(date.getMonth() + 1).padStart(2, '0');
  const prevDay = String(date.getDate()).padStart(2, '0');

  return `${prevYear}-${prevMonth}-${prevDay}`;
};

export const buildPersonOptions = (people = [], badge = 'User') => (
  toDerasarPersonOptions(people, { badge })
);

export const getNumericAmount = (value) => parseFloat(value || 0);
